<form [formGroup]="addDataLakeForm" (ngSubmit)="onSubmit()">
    <div class="dialog-header"> 
        <h2 class="dialog-title">Tenant Data Lake Creation</h2>   
        <button class="cancel-button" mat-button type="button" [disabled]="isSubmitting()" (click)="onCancel()">Cancel</button>
    </div>
    <div class="dialog-body">
        <mat-dialog-content class="dialog-form">
            <div formArrayName="dataLakes">
                @for (dataLakeInput of dataLakeInputs.controls; track dataLakeInput.get('id')?.value) {
                    <div class="data-lake-form" [formGroupName]="$index"> 
                        <button class="delete-data-lake-button" mat-stroked-button 
                            color="primary"
                            type="button" 
                            [disabled]="dataLakeInputs.length <= 1"
                            (click)="removeDataLakeInput($index)"> 
                            <mat-icon class="delete-icon">delete</mat-icon>
                            Remove
                        </button>
                        <mat-form-field class="data-lake-name-field">
                            <mat-label>Data Lake Name</mat-label>
                            <input class="input" matInput formControlName="value">
                            @if (dataLakeInput.get('value')?.errors?.['required']) {
                                <mat-error>Data lake name is required.</mat-error>
                            }
                            @if (dataLakeInput.get('value')?.errors?.['pattern']) {
                                <mat-error>Data lake name must be 3-63 characters long and can only contain letters, numbers, and dashes.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
            </div>
            @if (dataLakeInputs.hasError("notUnique") && dataLakeInputs.touched) {
                <mat-error>Data lake names must be unique.</mat-error>
            }
            <button class="add-data-lake-button" mat-stroked-button 
                color="primary"
                type="button" 
                [disabled]="dataLakeInputs.length >= 10"
                (click)="addDataLake()"> 
                <mat-icon>add</mat-icon>
                Add Data Lake
            </button>
        </mat-dialog-content>     
    </div>
    <mat-dialog-actions class="dialog-footer">
        <button class="submit-button" mat-flat-button 
            color="primary"
            type="submit" 
            [disabled]="!addDataLakeForm.valid || isSubmitting()"> 
            @if (!isSubmitting()) {
                Create Data Lakes
            } @else {
                <div class="submit-loading-spinner" matSuffix>
                    <app-loading-spinner [strokeWidth]="5"></app-loading-spinner>
                </div>
            }
        </button>
    </mat-dialog-actions>
</form>